import { render, staticRenderFns } from "./autoMergeOrderSettingDialog.vue?vue&type=template&id=c143468a&scoped=true"
import script from "./autoMergeOrderSettingDialog.vue?vue&type=script&lang=js"
export * from "./autoMergeOrderSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./autoMergeOrderSettingDialog.vue?vue&type=style&index=0&id=c143468a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c143468a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c143468a')) {
      api.createRecord('c143468a', component.options)
    } else {
      api.reload('c143468a', component.options)
    }
    module.hot.accept("./autoMergeOrderSettingDialog.vue?vue&type=template&id=c143468a&scoped=true", function () {
      api.rerender('c143468a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/components/autoMergeOrderSettingDialog.vue"
export default component.exports